import React, { useState } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  animation-duration: 0.3s;
`;

const StyledIframe = styled.iframe`
  border: none;
`;

const Docs = ({ children, scrolTo, docsUrl }) => {
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const childrenRoot = React.Children.only(children);
  const newchild = React.cloneElement(childrenRoot, {
    onClick: () => {
      showModal();
    },
  });

  return (
    <>
      {newchild}
      <StyledModal
        title="Analytics manual"
        open={visible}
        onCancel={handleCancel}
        footer={null}
        width="1020px"
        centered
        destroyOnClose
        bodyStyle={{
          height: '80vh',
          padding: '0',
        }}
      >
        <StyledIframe title="docs" width="100%" height="100%" src={`${docsUrl}#${scrolTo}`} />
      </StyledModal>
    </>
  );
};

export default Docs;
